import { ICollectionReference } from '../database-cast/IDatabase';



export interface MayHaveId {
    id: string | number;
}

export class DbListBase<T extends MayHaveId> {
    protected _collection: ICollectionReference;


    constructor(collection: ICollectionReference) {
        this._collection = collection;

    }

    public getCollection() {
        return this._collection;
    }

    // getData(): Promise<T[]> {

    //     let promise: Promise<T[]> = new Promise((resolve, reject) => {

    //         this._collection
    //             .get()
    //             .then((querySnapshot: any) => {

    //                 let results: Array<T> = [];
    //                 querySnapshot.forEach(doc => {
    //                     let result = doc.data();

    //                     result.id = doc.id;

    //                     results.push(result);
    //                 });

    //                 resolve(results);

    //             })
    //             .catch(error => {
    //                 reject(error);
    //             });


    //     });


    //     return promise;

    // }

    getData(orderParam: string = null): Promise<T[]> {

        let promise: Promise<T[]> = new Promise((resolve, reject) => {

            if (orderParam == null) {

                this._collection.get()
                    .then((querySnapshot: any) => {

                        let results: Array<any> = [];
                        querySnapshot.forEach(doc => {
                            let result = doc.data();

                            result.id = doc.id;

                            results.push(result);
                        });


                        resolve(results);

                    })
                    .catch(error => {
                        reject(error);
                    });

            }
            else {

                this._collection
                    .orderBy(orderParam)
                    .get()
                    .then((querySnapshot: any) => {

                        let results: Array<any> = [];
                        querySnapshot.forEach(doc => {
                            let result = doc.data();

                            result.id = doc.id;

                            results.push(result);
                        });


                        resolve(results);

                    })
                    .catch(error => {
                        reject(error);
                    });
            }
        });


        return promise;

    }

    public add(object: T): Promise<T> {

        let promise = new Promise<T>((resolve, reject) => {


            let jsonObject = JSON.parse(JSON.stringify(object));



            this._collection.add(jsonObject)
                .then(docReference => {


                    //  task.id = docReference.id;

                    if (object.id == null) {
                        object.id = docReference.id;
                    }

                    resolve(object);
                }).
                catch(error => {


                    reject(error);

                });
        });


        return promise;
    }

    public set(id: string, object: T): Promise<T> {

        let promise = new Promise<T>((resolve, reject) => {


            let jsonObject = JSON.parse(JSON.stringify(object));



            this._collection.doc(id).set(jsonObject)
                .then(() => {


                    resolve(object);
                }).
                catch(error => {


                    reject(error);

                });
        });


        return promise;
    }

}